import { KeyValuePipe } from './../pipes/keyvalue_pipe';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { LegalFrameworkComponent } from './legal-framework.component';
import { LegalFrameworkPageComponent } from "app/legal-framework/lf-page/lf-page.component";


const routes: Routes = [
  {
    path: '',
    component: LegalFrameworkComponent,
    children: [{
      path: ':id',
      component: LegalFrameworkPageComponent,
    }]
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class LegalFrameworkRoutingModule { }

export const routedComponents = [
  LegalFrameworkComponent, LegalFrameworkPageComponent
];



// WEBPACK FOOTER //
// ./src/app/legal-framework/legal-framework-routing.module.ts